import React, {useEffect, useState} from "react";
import axios from "axios";
import SimpleBar from "simplebar-react";
import {Alert} from "reactstrap";
import Select from "react-select";
import customStyles from "../../assets/select/customStyles";
import HTMLReactParser from 'html-react-parser';
import {AvForm} from "availity-reactstrap-validation";
import {useTranslation} from "react-i18next";

const ReservierungImport= (props) => {
    const { t } = useTranslation();
    const [departments, setDepartments] = useState([]);
    const [allParkingscenarios, setAllParkingscenarios] = useState([]);
    const [currentParkingscenarios, setCurrentParkingscenarios] = useState([]);
    const [carParks, setCarParks] = useState([]);

    const [selectedDepartment, setSelectedDepartment] = useState();
    const [selectedScenario, setSelectedScenario] = useState();
    const [selectedCarPark, setSelectedCarPark] = useState();

    const [file, setFile] = useState(null);
    
    const [errorMessage, setErrorMessage] = useState('');

    const activeRights = JSON.parse(localStorage.getItem("rights"));
    const link = localStorage.getItem('link') + '/api/ReservationService';

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("JWT");
        loadData();
    }, []);

    const loadData = () => {
        // Trotzdem Edit laden um an die Grunddaten zu kommen.
        axios.get(link + '/byid?id=', {}).then((response) => {
            console.debug(response.data);

            const carParks = response.data.carParks;

            setDepartments(response.data.departments);
            setCarParks(carParks);

            setSelectedDepartment(response.data.model.department);
            setSelectedScenario(response.data.model.scenario);

            const _selectedCarPark = carParks.find(cp => cp.value === response.data.model.areaIdCarpark);
            setSelectedCarPark(_selectedCarPark);

            setAllParkingscenarios(response.data.parkingScenariosByCarPark);
            changeCurrentParkingscenarios(response.data.parkingScenariosByCarPark, _selectedCarPark.value);
        })
            .catch((error) => {
                console.error("Error while loading Data", error);
            });
    }

    function changeCurrentParkingscenarios(allScenarios, selectedCarParkId) {
        const _currentScenarios = allScenarios[selectedCarParkId];
        setCurrentParkingscenarios(_currentScenarios);
    }

    async function handleValidSubmit() {
        setErrorMessage('');
        
        const formData = new FormData();
        formData.append('file', file);
        formData.append('areaIdCarpark', selectedCarPark.value);
        formData.append('departmentId', selectedDepartment.value);
        formData.append('scenarioId', selectedScenario?.value || '');
        
        console.debug(formData);

        axios
        ({
            method: 'post',
            url: link + '/Import',
            data: formData,
        })
            .then((response) => {
                props.onChange();
            })
            .catch((error) => {
                if (error.response.data) {
                    let txt = '';
                    error.response.data.forEach((entry) => {
                        const res = entry.reservation;
                        txt += `${res.firstname} ${res.lastname} ${res.numberPlate}: `;
                        txt += entry.errorCodes.map((code) => getErrorMessage(parseInt(code))).join(',');
                        txt += '<br />';
                    });
                    setErrorMessage(txt);
                } else {
                    console.error(error);
                    setErrorMessage(error.message);
                }
            });
        function getErrorMessage(statusCode) {
            switch (statusCode) {
                case 900:
                    return t("reservationService.quotaExceeded");
                case 901:
                    return t("reservationService.plateAllreadyReserved");
                case 902:
                    return t("reservationService.noCarParkGiven");
                case 903:
                    return t("reservationService.noTimeSpanGiven");
                case 904:
                    return t("reservationService.noNameGiven");
                case 905:
                    return t("reservationService.noCompanyGiven");
                case 906:
                    return t("reservationService.noEmailGiven");
                case 907:
                    return t("reservationService.noLPGiven");
            }

            return null;
        }
    }

    return (
        <SimpleBar style={{width: "100%", height: "100%"}}>
            <div style={{width: "80%", margin: "auto"}}>
                <div style={{ marginTop: "20px" }}>
                    <h3>
                        {t("reservationService.reservationImport")}
                    </h3>
                    <AvForm
                        className="form-horizontal"
                        onValidSubmit={async () => {
                            await handleValidSubmit();
                        }}
                    >
                        {props.error && props.error ? (
                            <Alert color="danger">{props.error}</Alert>
                        ) : null}
                        <table border={0}>
                            <colgroup>
                                <col/>
                            </colgroup>
                            <tbody>
                            <tr>
                                <td style={{position: "relative", top: "-9px"}}>
                                    <a href={"ReservationSystemImportVorlage.xlsx"}>{t("reservationService.vorlageHerunterladen")}</a>
                                </td>
                            </tr>
                            <tr>
                                <td style={{position: "relative", top: "-9px"}}>
                                    <div style={{marginBottom: "10px"}}>{t("reservationService.formHeader.carPark")}:</div>
                                    <Select
                                        styles={customStyles}
                                        name="areaIdCarpark"
                                        closeMenuOnSelect={true}
                                        isSearchable={false}
                                        isMulti={false}
                                        onChange={(carPark) => {
                                            setSelectedCarPark(carPark);
                                            changeCurrentParkingscenarios(allParkingscenarios, carPark.value);
                                        }}
                                        options={carParks}
                                        value={selectedCarPark}
                                        required
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 3,
                                            colors: { ...theme.colors, primary: "#20a0ff" },
                                        })}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td style={{paddingTop: "20px"}}>
                                    <div style={{marginBottom: "10px"}}>{t("reservationService.formHeader.department")}:</div>
                                    <Select
                                        styles={customStyles}
                                        closeMenuOnSelect={true}
                                        isSearchable={false}
                                        isMulti={false}
                                        onChange={(department) => {
                                            setSelectedDepartment(department);
                                        }}
                                        options={departments}
                                        value={selectedDepartment}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td style={{paddingTop: "20px"}}>
                                    <div style={{marginBottom: "10px"}}>{t("reservationService.formHeader.scenario")}:</div>
                                    <Select
                                        styles={customStyles}
                                        closeMenuOnSelect={true}
                                        isSearchable={false}
                                        isMulti={false}
                                        onChange={(scenario) => {
                                            setSelectedScenario(scenario);
                                        }}
                                        options={currentParkingscenarios}
                                        value={selectedScenario}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td style={{paddingTop: "20px"}}>
                                    <div style={{marginBottom: "10px"}}>{t("reservationService.formHeader.importFile")}:</div>
                                    <input required={true} type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onChange={(e)=>{
                                        if (e.target.files) {
                                            setFile(e.target.files[0]);
                                        }
                                    }} />
                                </td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr>
                                <td style={{textAlign: "right", paddingTop: "20px"}}>
                                    <button className="button" onClick={() => props.onChange()} style={{width: "100px"}}>
                                        {t("allgemein.abbruch")}
                                    </button>

                                    <button type="submit" className="button" disabled={file == null} style={{width: "100px", marginLeft: "10px"}}>
                                        {t("allgemein.speichern")}
                                    </button>
                                </td>
                            </tr>
                            {errorMessage !== '' && (
                                <tr><td style={{textAlign: "right", color: "#f46a6a"}}>{HTMLReactParser(errorMessage)}</td></tr>
                            )}
                            </tfoot>
                        </table>
                    </AvForm>
                </div>
            </div>
        </SimpleBar>
    );
};

export default ReservierungImport;
